export default "__VITE_ASSET__DCK2Op2p__"